var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"jobs",class:`${_vm.visible ? '' : 'invisible'}`},[_c('Header',{attrs:{"withSearch":true}}),_c('MyProfile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }